import { GET_COVER_PREVIEW } from 'modules/v2/editor/store/constants';

export const getCoverPreview = () => ({
  type: GET_COVER_PREVIEW,
});
